import * as Yup from 'yup';

const colorSchema = Yup.object().shape({
  colorCode: Yup.string().required('Color Code is required.'),
  labelEn: Yup.string().trim().required('English is required.'),
  labelAr: Yup.string().trim().required('Arabic is required.'),
  // colorType: Yup.string().required('Color Type is required.'),
  position: Yup.number()
    .min(1, "Please enter more than 1")
    .typeError("Must be Number"),
});

export default colorSchema;